import React from "react";
import { Input } from "@/components/ui/input";
import { MagnifyingGlass } from "@phosphor-icons/react";

export const DesignFilters = ({ f, setF, customers }) => {
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <div className="relative">
        <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <Input value={f.q} onChange={set("q")} placeholder="D-5 / 5 / order no. / file naam"
          className="pl-9 rounded-sm bg-slate-950 border-slate-700 h-10" data-testid="designs-search-input" />
      </div>
      <Input value={f.customer} onChange={set("customer")} list="designs-customers" placeholder="Customer ka naam"
        className="rounded-sm bg-slate-950 border-slate-700 h-10" data-testid="designs-customer-input" />
      <datalist id="designs-customers">
        {customers.map((c) => <option key={c} value={c} />)}
      </datalist>
      <Input value={f.size} onChange={set("size")} placeholder="Size (W x H) e.g. 22x76.4"
        className="rounded-sm bg-slate-950 border-slate-700 h-10" data-testid="designs-size-input" />
    </div>
  );
};
